import gql from "graphql-tag";

const FLIGHTS_ASSIGNEMENTS_PAGE_FLIGHT_FRAGMENT = gql`
    fragment FlightsAssignmentsPage_Flight on Flight {
        id airline number date initialDate destination planeIdentifier parking { id name } galery { id name } flightType
        baggages { id number date status location object { id name } importedBy }
        tasks { id mission { id tasks { id name processedBaggages } humanResource { id identifier firstName lastName } equipmentResource { id identifier } type { color } status currentState { id name }  } }
    }
`;

export const FLIGHTS_ASSIGNEMENTS_PAGE_LOAD_FLIGHTS_QUERY = gql`
    query FlightsAssignmentsPage_loadFlightsQuery($params: FindByFilterParamsInput) { 
        flightService_findByFilter(params: $params) {
            results  { ...FlightsAssignmentsPage_Flight } 
        }
    }
    ${FLIGHTS_ASSIGNEMENTS_PAGE_FLIGHT_FRAGMENT}
`;

export const FLIGHTS_ASSIGNEMENTS_PAGE_CREATE_MISSION = gql`
    mutation FlightsAssignmentsPage_createMissionMutation($flightId:Long!,$humanResourceId:Long,$comment:String,$objectStartAddressId:Long,$missionTypeId:Long,$taskId:Long) { 
        mission2Service_createMission(flightId:$flightId,humanResourceId:$humanResourceId,comment:$comment,objectStartAddressId:$objectStartAddressId,missionTypeId:$missionTypeId,taskId:$taskId)
    }
`;

const MISSIONS_AWAITING_FOR_DRIVERS_PAGE_MISSION_FRAGMENT = gql`
    fragment MissionsAwaitingForDriversPage_Mission on Mission2 {
        id creationDate comment comment2 isSpecial startTime endTime type { id name color } startAddress { id name } endAddress { id name } equipmentResource { id identifier equipmentType { id name } } 
        tasks { id name startAddress { id name } endAddress {id name } taskGroup { id name departure planeIdentifier flightType lastKnownDateType date parking { id name } } }
    }    
`;

export const MISSIONS_AWAITING_FOR_DRIVERS_PAGE_LOAD_MISSIONS_QUERY = gql`
    query MissionsAwaitingForDriversPage_loadMissionsQuery($params: FindByFilterParamsInput) { 
        mission2Service_findByFilter(params: $params) {
            results  { ...MissionsAwaitingForDriversPage_Mission } 
        }
    }
    ${MISSIONS_AWAITING_FOR_DRIVERS_PAGE_MISSION_FRAGMENT}
`;

const MISSIONS_AWAITING_FOR_DRIVERS_PAGE_SETTINGS_FRAGMENT = gql`
    fragment MissionsAwaitingForDriversPage_Settings on MissionsAwaitingForDriversPageSettings {
        filters workWithTasks showDepartureFilter showFlightTypeFilter showLastKnownDateTypeFilter
    }
`;

export const MISSIONS_AWAITING_FOR_DRIVERS_PAGE_LOAD_SETTINGS = gql`
    query MissionsAwaitingForDriversPage_loadSettingsQuery { 
        mission2Service_missionsAwaitingForDriversPageSettings { 
            ...MissionsAwaitingForDriversPage_Settings
         }
    }
    ${MISSIONS_AWAITING_FOR_DRIVERS_PAGE_SETTINGS_FRAGMENT}
`;


const MISSIONS_AWAITING_FOR_DRIVERS_PAGE_TASK_FRAGMENT = gql`
    fragment MissionsAwaitingForDriversPage_Task on Task {
        id offset duration startTime endTime missionType { id name color } startAddress { id name } endAddress { id name } mission { id } taskGroup { id name departure planeIdentifier flightType lastKnownDateType date parking { id name } }
    }    
`;

export const MISSIONS_AWAITING_FOR_DRIVERS_PAGE_LOAD_TASKS_QUERY = gql`
    query MissionsAwaitingForDriversPage_loadTasksQuery($params: FindByFilterParamsInput) { 
        taskService_findByFilter(params: $params) {
            results  { ...MissionsAwaitingForDriversPage_Task } 
        }
    }
    ${MISSIONS_AWAITING_FOR_DRIVERS_PAGE_TASK_FRAGMENT}
`;

export const MISSIONS_AWAITING_FOR_DRIVERS_PAGE_ASSIGN_HUMAN_RESOURCE_TO_MISSION = gql`
    mutation mission2Service_assignHumanResourceToMission($missionId: Long, $humanResourceId: Long) {
        mission2Service_assignHumanResourceToMission(missionId: $missionId, humanResourceId: $humanResourceId)
    }
`;
